import { useTranslation } from 'react-i18next';

import { Icon } from '~/chords/Icon';
import { Tag } from '~/chords/Tag';
import { Tooltip } from '~/chords/Tooltip';

export interface SelectedItemChip {
  value: string;
  label: string;
}

interface SelectedItemChipsProps {
  items: SelectedItemChip[];
  onRemove: (value: string) => void;
  disabled?: boolean;
}

export function SelectedItemChips({
  items,
  onRemove,
  disabled = false,
}: SelectedItemChipsProps) {
  const { t } = useTranslation('chords');

  if (!items.length) {
    return null;
  }

  return (
    <div className="flex flex-wrap gap-sm">
      {items.map((item) => (
        <Tag key={item.value} variant="secondary" size="lg" disabled={disabled}>
          <Tooltip content={item.label} spacing="wide" triggerAsChild>
            <span className="max-w-xs truncate">{item.label}</span>
          </Tooltip>

          {!disabled ? (
            <button
              type="button"
              aria-label={t('multiSelect.removeItem', {
                label: item.label,
              })}
              onClick={() => onRemove(item.value)}
            >
              <Icon type="xmark" size="sm" aria-hidden />
            </button>
          ) : null}
        </Tag>
      ))}
    </div>
  );
}

SelectedItemChips.displayName = 'SelectedItemChips';
